import Skeleton from '@mui/material/Skeleton';
import { ChartColumnBig, RefreshCw } from 'lucide-react';
import './FormsAnalyticsPanel.scss';

export default function FormsAnalyticsPanel({ forms, loading, error, onRetry }) {
    const className = 'formsAnalyticsPanel';

    if (loading) {
        return (
            <div className={className + '__grid'}>
                {[0, 1, 2, 3].map((i) => (
                    <Skeleton key={i} variant="rounded" height={190} />
                ))}
            </div>
        );
    }

    if (error) {
        return (
            <div className={className + '__state'}>
                <ChartColumnBig className={className + '__state__icon'} />
                <p className={className + '__state__text'}>Couldn't load forms analytics.</p>
                {onRetry && (
                    <button type="button" className={className + '__state__retry'} onClick={onRetry}>
                        <RefreshCw />
                        Try again
                    </button>
                )}
            </div>
        );
    }

    if (!forms || forms.length === 0) {
        return (
            <div className={className + '__state'}>
                <ChartColumnBig className={className + '__state__icon'} />
                <p className={className + '__state__text'}>Create a form to start seeing analytics here.</p>
            </div>
        );
    }

    return (
        <div className={className + '__grid'}>
            {forms.map((form) => {
                const statusList = form.statusList || [];
                const totalForBar = statusList.reduce((sum, s) => sum + (s.count || 0), 0);

                return (
                    <div key={form.formId} className={className + '__card'}>
                        <div className={className + '__card__title'} title={form.title}>
                            {form.title}
                        </div>

                        <div className={className + '__card__stats'}>
                            <div className={className + '__card__stats__stat'}>
                                <span className={className + '__card__stats__stat__value'}>
                                    {form.totalTickets ?? 0}
                                </span>
                                <span className={className + '__card__stats__stat__label'}>Total tickets</span>
                            </div>
                            <div className={className + '__card__stats__stat'}>
                                <span className={className + '__card__stats__stat__value'}>
                                    {form.reporters ?? 0}
                                </span>
                                <span className={className + '__card__stats__stat__label'}>Reporters</span>
                            </div>
                            <div className={className + '__card__stats__stat'}>
                                <span className={className + '__card__stats__stat__value'}>
                                    {form.averageTickets ?? 0}
                                </span>
                                <span className={className + '__card__stats__stat__label'}>Avg / reporter</span>
                            </div>
                        </div>

                        {statusList.length > 0 && (
                            <div className={className + '__card__breakdown'}>
                                {totalForBar > 0 && statusList.length > 1 && (
                                    <div className={className + '__card__breakdown__bar'} aria-hidden="true">
                                        {statusList.map((s) => (
                                            <span
                                                key={s.id}
                                                style={{
                                                    width: `${((s.count || 0) / totalForBar) * 100}%`,
                                                    background: s.status?.color || 'var(--dbp-text-muted)',
                                                }}
                                            />
                                        ))}
                                    </div>
                                )}
                                <div className={className + '__card__breakdown__legend'}>
                                    {statusList.map((s) => (
                                        <div key={s.id} className={className + '__card__breakdown__legend__row'}>
                                            <span
                                                className={className + '__card__breakdown__legend__row__dot'}
                                                style={{ background: s.status?.color || 'var(--dbp-text-muted)' }}
                                            />
                                            <span
                                                className={className + '__card__breakdown__legend__row__label'}
                                                title={s.status?.title}
                                            >
                                                {s.status?.title}
                                            </span>
                                            <span className={className + '__card__breakdown__legend__row__count'}>
                                                {s.count}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
